import React, { FunctionComponent, memo } from "react";
import { Table } from "@chakra-ui/react";
import { isEqual } from "lodash";

import SourceMetric from "./SourceMetric";

import { PlcMetrics } from "../types";


interface IProps{
  metrics?: PlcMetrics;
}


const SourceMetrics: FunctionComponent<IProps> = memo(function SourceMetrics({
  metrics,
  children,
}) {
  return <>
    <Table variant="unstyled" cellPadding={0}>
      {children}
      {metrics && Object.entries(metrics).map(([metric, value]) => metric !== "kw_active_power" && (
        <SourceMetric name={metric} value={value} />
      ))}
    </Table>
  </>
}, isEqual);

export default SourceMetrics;
